/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() { 
  // Add custom code below this line

document.addEventListener('DOMContentLoaded', function() {

    //PDP custom
    const toggleCheckbox = document.getElementById('toggle-checkbox');
    const noAssemblyLabel = document.querySelector('#assembly-toggle-1');
    const whiteGloveLabel = document.querySelector('#assembly-toggle-2');
  
    if (toggleCheckbox && noAssemblyLabel && whiteGloveLabel) {
    toggleCheckbox.addEventListener('change', function() { 
      if (toggleCheckbox.checked) {
        whiteGloveLabel.click();
      } else {
        noAssemblyLabel.click(); 
      }
    });
  }

  //Navigation Redesign
  document.querySelectorAll('.second-level-links').forEach(link => {
    link.addEventListener('click', function(event) {
      event.stopPropagation();

      if (link.classList.contains('third-level-open')) {
        link.classList.remove('third-level-open');
      } else {
        document.querySelectorAll('.second-level-links.third-level-open').forEach(otherLink => {
          otherLink.classList.remove('third-level-open');
        });

        link.classList.add('third-level-open');

      }
    });
  });

  document.querySelectorAll('.header__menu .menu__item').forEach(item => {
    const closeButton = item.querySelector('.nav-close');
    const dropdown = item.querySelector('.header__dropdown');
    
    if (dropdown) {
      item.addEventListener('click', function() {
        document.querySelectorAll('.header__menu .menu__item .header__dropdown').forEach(dropdown => {
        dropdown.classList.remove('is-visible');
      });

        document.body.classList.remove('no-scroll');
        dropdown.classList.toggle('is-visible');

        if (dropdown.classList.contains('is-visible')) {
          document.body.classList.add('no-scroll');
        }
      });

      if (closeButton) {
        closeButton.addEventListener('click', function(event) {
          event.stopPropagation();
          dropdown.classList.remove('is-visible');
          document.body.classList.remove('no-scroll');

          document.querySelectorAll('.grandchildren-wrapper').forEach(nav => {
            nav.classList.remove('nav-show');
          });

          document.querySelectorAll('.navlink--child.links-level').forEach(nav => {
            nav.classList.remove('nav-active');
          });

        });
      }
    }

    item.querySelectorAll('.navlink--child.links-level .navtext').forEach(navText => {
      navText.parentElement.addEventListener('click', function(event) {
        document.querySelectorAll('.navlink--child.links-level').forEach(nav => {
          nav.classList.remove('nav-active')
        })
        navText.parentElement.classList.add('nav-active');

        const clickedText = navText.textContent.trim();
        const targetNav = document.querySelector(`.grandchildren-nav[data-id="${clickedText}"]`);

        if (targetNav) {

          document.querySelectorAll('.grandchildren-nav').forEach(nav => {
            nav.classList.remove('nav-visible');
            nav.parentElement.classList.add('nav-show');
          });

          targetNav.classList.toggle('nav-visible');

        }
      });
    });
  });
});


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
